import { IMG_KPO } from './competitionBranding';

export const PublicHeader = () => (
  <header className="relative z-10 w-full bg-white">
    <div className="mx-auto flex max-w-6xl items-center justify-center px-6 py-3">
      <img src={IMG_KPO} alt="Finansowane z KPO" className="h-10 object-contain" />
    </div>
  </header>
);
